import styled from 'styled-components/macro';
import EntityItem from 'components/base/EntityItem/EntityItem';
import { ArtworkWrapper } from 'components/base/EntityItem/EntityItem.style';
import ErrorBoundary from 'components/utility/ErrorBoundary/ErrorBoundary';
import SearchResultsLoader from 'components/utility/ContentLoader/SearchResultsLoader/SearchResultsLoader';

import { definitionLabel, boxShadow } from 'styles/base-classes';

export const SearchResults = styled('div')<any>`
  background: white;
  color: ${({ theme }) => theme.NightBlue};
  padding: ${({ theme }) => `${theme.spacing.medium} 0`};
  overflow-y: ${({ smoothScrolling }) => (smoothScrolling ? 'scroll' : 'auto')};
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
  max-height: 15em;
  position: relative;

  @media screen and (min-width: 30em) and (min-height: 50em) {
    max-height: 22.5em;
  }

  @media screen and (min-width: 30em) {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 100%;
    width: 100%;
    max-height: 30em;

    ${boxShadow};
  }
`;

export const SearchResult = styled('div')<any>`
  background: ${({ theme, isHighlighted }) =>
    isHighlighted ? theme.Sand : 'none'};
  cursor: default;
  border-bottom: 1px solid ${({ theme }) => theme.LightGrey};

  &:last-child {
    border-bottom: 0;
  }

  ${ArtworkWrapper} {
    margin-right: ${({ theme }) => theme.spacing.small};

    @media screen and (min-width: 30em) {
      margin-right: ${({ theme }) => theme.spacing.medium};
    }
  }
`;

export const StyledEntityItem = styled(EntityItem)`
  padding: ${({ theme }) => theme.spacing.small};

  @media screen and (min-width: 30em) {
    padding-left: ${({ theme }) => theme.spacing.large};
    padding-right: ${({ theme }) => theme.spacing.large};
  }

  > div:first-child {
    transition: ${({ theme }) =>
      `transform ${theme.transitionDuration} ${theme.timingFunction}`};
  }

  &:hover,
  &:focus {
    > div:first-child {
      transform: translateX(0.25em);
    }
  }
  &:active {
    background: ${({ theme }) => theme.LightGrey};
  }
`;

export const SuggestedTitle = styled('h3')`
  ${definitionLabel};
  margin-left: ${({ theme }) => theme.spacing.small};
  margin-right: ${({ theme }) => theme.spacing.small};

  @media screen and (min-width: 30em) {
    margin-left: ${({ theme }) => theme.spacing.xlarge};
    margin-right: ${({ theme }) => theme.spacing.xlarge};
  }
`;

export const StyledSearchResultsLoader = styled(SearchResultsLoader)`
  padding-left: ${({ theme }) => theme.spacing.small};
  padding-right: ${({ theme }) => theme.spacing.small};
  margin: 0;

  &:last-child {
    border-bottom: 0;
  }

  @media screen and (min-width: 30em) {
    padding-left: ${({ theme }) => theme.spacing.large};
    padding-right: ${({ theme }) => theme.spacing.large};
  }
`;

export const LoadingBarWrapper = styled('div')`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 3px;
  pointer-events: none;
`;

export const NoResultsSpacer = styled('div')`
  padding: 0 ${({ theme }) => theme.spacing.small};

  @media screen and (min-width: 30em) {
    padding: 0 ${({ theme }) => theme.spacing.large};
  }
`;

export const StyledErrorBoundary = styled(ErrorBoundary)`
  padding: 0 ${({ theme }) => theme.spacing.small};

  @media screen and (min-width: 30em) {
    padding: 0 ${({ theme }) => theme.spacing.large};
  }
`;
